<template>
  <div class="contents register userInfo">
    <section class="box one">
      <h2>단어 퀴즈 관리</h2>

      <div class="inputBox word">
        <div class="flex">
          <p>
            단어
            <span>*</span>
          </p>
          <input type="text" v-model="word" />
        </div>
        <div class="flex">
          <p>
            타입
            <span>*</span>
          </p>
          <el-select v-model="type">
            <el-option
              v-for="(item, i) in types"
              :key="i"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex">
          <p>
            카테고리
            <span>*</span>
          </p>
          <el-select v-model="category">
            <el-option
              v-for="(item, i) in categories"
              :key="i"
              :value="item"
              :label="getCategoryDisplayName(item)"
            >
            </el-option>
          </el-select>
        </div>
        <div v-if="type == 1" class="flex double">
          <p>
            문제
            <span>*</span>
          </p>
          <input type="text" v-model="question" />
        </div>

        <div v-if="type == 0" class="flex">
          <p>
            앞 문장
            <span>*</span>
          </p>
          <input type="text" v-model="phrase_front" />
        </div>

        <div v-if="type == 0" class="flex">
          <p>
            뒷 문장
            <span>*</span>
          </p>
          <input type="text" v-model="phrase_back" />
        </div>

        <div class="flex double">
          <p>
            보기
            <span>*</span>
          </p>
          <div class="flex desc">
            <input class="full" type="text" v-model="example1" />
            <input class="full" type="text" v-model="example2" />
            <input class="full" type="text" v-model="example3" />
          </div>
        </div>

        <div class="flex double">
          <p>
            해설
            <!-- <span>*</span> -->
          </p>
          <div class="flex desc sentence">
            <textarea
              class="full"
              :maxlength="180"
              v-model="comment_en"
              placeholder="영어 해설"
            />
            <p class="note-length">{{ (comment_en || "").length }} / 180</p>
            <textarea
              class="full"
              :maxlength="180"
              v-model="comment_jp"
              placeholder="일본어 해설"
            />
            <p class="note-length">{{ (comment_jp || "").length }} / 180</p>
          </div>
        </div>

        <!-- <div class="flex double">
          <p>
            예문
            <span>*</span>
          </p>
          <div class="flex desc sentence">
            <input
              class="full"
              type="text"
              v-model="description_en"
              placeholder="영어"
            />
            <input
              class="full"
              type="text"
              v-model="description_jp"
              placeholder="일본어"
            />
            <input
              class="full"
              type="text"
              v-model="description_cn"
              placeholder="중국어"
            />
            <input
              class="full"
              type="text"
              v-model="description_es"
              placeholder="스페인어"
            />
          </div>
        </div> -->
      </div>
      <div class="buttonWrap">
        <button class="basic" @click="submit">
          {{ editMode == true ? "수정" : "등록" }}
        </button>
        <button v-if="editMode" class="line" @click="handleDelete">삭제</button>
      </div>
    </section>
    <div class="buttonWrap">
      <router-link to="/admin/sentence/manage">
        <span class="material-icons-round"> keyboard_backspace </span
        >목록</router-link
      >
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  getSentenceCategoryDisplayName,
  getUniqueSentenceCategories,
} from "@/utils/sentenceCategoryDisplay";
import {
  createSentence,
  fetchSentence,
  updateSentence,
  removeSentence,
} from "@/api/admin";
export default {
  data() {
    return {
      editMode: false,
      moment: moment,
      category: "",
      word: "",
      question: "",
      phrase_front: "",
      phrase_back: "",
      examples: [],
      example1: "",
      example2: "",
      example3: "",
      type: 0,
      types: [
        { value: 0, label: "빈칸" },
        { value: 1, label: "문제" },
      ],
      comment_en: "",
      comment_jp: "",
      description_en: "",
      description_jp: "",
      description_cn: "",
      description_es: "",
      updatedAt: "",
      createdAt: "",
      categories: [],
      modalVisible: false,
    };
  },

  created() {
    this.$store.dispatch("SET_NAVBAR", "3");
  },
  mounted() {
    this.categories = getUniqueSentenceCategories();
    if (this.$route.query.id) {
      this.editMode = true;
      this.sentenceId = this.$route.query.id;
      this.getSentence();
    } else {
      if (this.$route.query.category) {
        this.category = this.$route.query.category;
      }
    }
  },
  methods: {
    getCategoryDisplayName(name) {
      return getSentenceCategoryDisplayName(name);
    },
    getSentence() {
      fetchSentence(this.sentenceId).then((res) => {
        console.log("detail", res.data.data);
        if (res.data.status == 200) {
          this.category = res.data.data.category;
          this.word = res.data.data.word;
          this.question = res.data.data.question;
          this.phrase_front = res.data.data.phrase_front;
          this.phrase_back = res.data.data.phrase_back;
          this.word_es = res.data.data.word_es;
          this.comment_en = res.data.data.comment_en;
          this.comment_jp = res.data.data.comment_jp;
          this.description_en = res.data.data.description_en;
          this.description_cn = res.data.data.description_cn;
          this.description_jp = res.data.data.description_jp;
          this.description_es = res.data.data.description_es;
          this.type = res.data.data.type;
          this.example1 = res.data.data.examples[0];
          this.example2 = res.data.data.examples[1];
          this.example3 = res.data.data.examples[2];
        } else {
          let message = res.data.message;
          alert(message);
        }
      });
    },

    handleDelete() {
      let result = confirm("삭제 하시겠습니까?");
      if (!result) {
        return;
      }
      removeSentence(this.sentenceId).then((res) => {
        if (res.data.status == 200) {
          alert("단어 정보가 삭제 되었습니다.");
          this.$router.replace("/admin/sentence/manage");
        }
      });
    },
    submit() {
      if (this.category == "") {
        return alert("카테고리를 선택해 주세요.");
      } else if (this.word == "") {
        return alert("단어를 입력해 주세요.");
      } else if (this.type !== 0 && !this.type) {
        return alert("타입을 선택해 주세요.");
      }
      if (this.type == 0) {
        if (this.phrase_front == "" && this.phrase_back == "") {
          return alert("앞문장 또는 뒷문장 중 하나 이상 입력해 주세요.");
        }
      } else if (this.type == 1) {
        if (this.question == "") {
          return alert("문제를 입력해 주세요.");
        }
      }

      const normalizedExamples = [
        this.example1,
        this.example2,
        this.example3,
      ].map((item) => (item || "").trim());

      if (normalizedExamples.some((item) => item === "")) {
        return alert("보기를 입력해 주세요.");
      }

      if (new Set(normalizedExamples).size !== normalizedExamples.length) {
        return alert("보기 3개는 서로 중복되면 안 됩니다.");
      }

      const normalizedWord = (this.word || "").trim();
      if (!normalizedExamples.includes(normalizedWord)) {
        return alert("단어와 보기 중 하나가 일치해야 합니다.");
      }

      const examples = normalizedExamples;

      let data = {
        sentenceId: this.sentenceId,
        category: this.category,
        word: this.word,
        type: this.type,
        comment_en: this.comment_en,
        comment_jp: this.comment_jp,
        description_en: this.description_en,
        description_jp: this.description_jp,
        description_cn: this.description_cn,
        description_es: this.description_es,
        examples,
      };
      if (this.type == 0) {
        data.phrase_front = this.phrase_front;
        data.phrase_back = this.phrase_back;
      } else if (this.type == 1) {
        data.question = this.question;
      }

      if (this.editMode) {
        updateSentence(data).then((res) => {
          if (res.data.status == 200) {
            alert("단어 퀴즈 정보가 반영 되었습니다.");
            this.$router.push("/admin/sentence/manage");
          } else {
            let message = res.data.message;
            alert(message);
          }
        });
      } else {
        createSentence(data).then((res) => {
          console.log(data);
          if (res.data.status == 200) {
            alert("단어 퀴즈 등록이 완료 되었습니다.");
            this.$router.push("/admin/sentence/manage");
          } else {
            let message = res.data.message;
            alert(message);
          }
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
textarea {
  width: 100% !important;
}
</style>
